export default "__VITE_ASSET__5b96bf60__"